import { CommonModule, DatePipe } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { FileUploadModule } from 'primeng/fileupload';

import { AngularMyDatePickerModule } from '../common/legacy-lib/angular-mydatepicker/angular-mydatepicker.module';
import { FmCheckboxModule } from '../fannie-mae-cdx-components/fm-checkbox/fm-checkbox.module';
import { DragDropFileDirective } from '../shared/directives/drag-drop-file.directive';
import { UptoThreeDecimalDirective } from '../shared/directives/upto-three-decimal.directive';
import { CdxApiGatewayHttpService } from '../shared/services/cdx-api-gateway-http.service';
import { SharedModule } from '../shared/shared.module';
import { AllocatePoolsComponent } from './allocate-pools/allocate-pools.component';
import { BulkUploadConfirmationPageComponent } from './bulk-upload-confirmation-page/bulk-upload-confirmation-page.component';
import { BulkUploadMegasContainerComponent } from './bulk-upload-megas-container/bulk-upload-megas-container.component';
import { BulkUploadReviewAndCommitComponent } from './bulk-upload-review-and-commit/bulk-upload-review-and-commit.component';
import { CollateralAnalyzerConfirmationComponent } from './collateral-analyzer-confirmation/collateral-analyzer-confirmation.component';
import { CollateralAnalyzerDetailsComponent } from './collateral-analyzer-details/collateral-analyzer-details.component';
import { CollateralAnalyzerErrorContainerComponent } from './collateral-analyzer-error-container/collateral-analyzer-error-container.component';
import { CollateralAnalyzerExcelComponent } from './collateral-analyzer-excel/collateral-analyzer-excel.component';
import { CollateralAnalyzerReviewAndCommitComponent } from './collateral-analyzer-review-and-commit/collateral-analyzer-review-and-commit.component';
import { CollateralAnalyzerStatisticsComponent } from './collateral-analyzer-statistics/collateral-analyzer-statistics.component';
import { CollateralAnalyzerTableComponent } from './collateral-analyzer-table/collateral-analyzer-table.component';
import { CollateralAnalyzerUploadFileComponent } from './collateral-analyzer-upload-file/collateral-analyzer-upload-file.component';
import { CommittedMegaTableComponent } from './committed-mega-table/committed-mega-table.component';
import { CommittedMegaComponent } from './committed-mega/committed-mega.component';
import { ConfirmationPageComponent } from './confirmation-page/confirmation-page.component';
import { EnterMegaTradeDetailsComponent } from './enter-mega-trade-details/enter-mega-trade-details-component';
import { FmXlsxJsonComponent } from './fm-xlsx-json/fm-xlsx-json.component';
import { MegaTradeContainerComponent } from './mega-trade-container/mega-trade-container';
import { MegaTradeRoutingModule } from './mega-trade-routing.module';
import { ReviewAndCommitComponent } from './review-and-commit/review-and-commit.component';
import { ReviewMegaPricingComponent } from './review-mega-pricing/review-mega-pricing.component';
import { AnalyzerDisclosureService } from './services/analyzer-disclosure.service';
import { MegasService } from './services/megas.service';
import { PassDataService } from './services/pass-data.service';
import { SettledMegasComponent } from './settled-megas/settled-megas.component';
import { UploadPoolConfirmationPageComponent } from './upload-pool-confirmation-page/upload-pool-confirmation-page.component';
import { UploadPoolInfoContainerComponent } from './upload-pool-info-container/upload-pool-info-container.component';
import { UploadPoolInfoComponent } from './upload-pool-info/upload-pool-info.component';
import { ValidatePoolsComponent } from './vadidate-pools/validate-pools.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MegaTradeRoutingModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    SharedModule,
    FileUploadModule,
    AngularMyDatePickerModule,
    FmCheckboxModule,
    CollateralAnalyzerExcelComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    ConfirmationPageComponent,
    EnterMegaTradeDetailsComponent,
    MegaTradeContainerComponent,
    ReviewAndCommitComponent,
    UptoThreeDecimalDirective,
    SettledMegasComponent,
    CommittedMegaComponent,
    CommittedMegaTableComponent,
    ReviewMegaPricingComponent,
    UploadPoolInfoComponent,
    UploadPoolInfoContainerComponent,
    UploadPoolConfirmationPageComponent,
    DragDropFileDirective,
    ValidatePoolsComponent,
    AllocatePoolsComponent,
    BulkUploadMegasContainerComponent,
    BulkUploadReviewAndCommitComponent,
    BulkUploadConfirmationPageComponent,
    CollateralAnalyzerUploadFileComponent,
    CollateralAnalyzerReviewAndCommitComponent,
    CollateralAnalyzerConfirmationComponent,
    FmXlsxJsonComponent,
    CollateralAnalyzerTableComponent,
    CollateralAnalyzerErrorContainerComponent,
    CollateralAnalyzerDetailsComponent,
    CollateralAnalyzerStatisticsComponent,
  ],
  providers: [
    provideHttpClient(),
    AnalyzerDisclosureService,
    MegasService,
    PassDataService,
    DatePipe,
    CdxApiGatewayHttpService,
  ],
})
export class MegaTradeModule {}
